"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var BatchSearcher = /** @class */ (function () {
    function BatchSearcher() {
    }
    BatchSearcher.prototype.search = function (article) {
        return axios_1.default.get(process.env.VUE_APP_API_URL + process.env.VUE_APP_CATALOG_PROXY_BATCH_URL + ("?article=" + article))
            .then(function (response) {
            return Array.isArray(response.data)
                ? response.data.map(function (batch) {
                    return {
                        "article": batch.article,
                        "name": batch.name,
                    };
                })
                : [];
        });
    };
    BatchSearcher.prototype.signGeometry = function (article) {
        return axios_1.default.get(process.env.VUE_APP_API_URL + process.env.VUE_APP_CATALOG_PROXY_SIGN_GEOMETRY_URL + ("?article=" + article))
            .then(function (response) {
            return Promise.resolve({ batch: response.data.batch, points: response.data.points });
        });
    };
    return BatchSearcher;
}());
exports.default = BatchSearcher;
//# sourceMappingURL=BatchSearcher.js.map